import { Box, Button, Grid, Tooltip, Typography } from "@mui/material";
import { DiscoverTabView, DiscoverViewContext } from "contexts/DiscoverView";
import { OrganizationUserContext } from "contexts/Organization";
import { TrackedCreatorsContext } from "contexts/TrackedCreators";
import { useContext } from "react";

import { trackEvent } from "utils/tracking";
import { usePageSize } from "utils/usePageSize";

import { getStyles } from "./styles";

function HomeSideBar() {
  const { hasBanner } = usePageSize();
  const { currentOrg } = useContext(OrganizationUserContext);
  const { discoverTab, tabWidth, setDiscoverTab, setOpenVaSettings } =
    useContext(DiscoverViewContext);
  const { setTrackedCreatorSideBar } = useContext(TrackedCreatorsContext);

  const tabOpen = discoverTab !== null;
  const styles = getStyles(tabOpen ? `${tabWidth}px` : "0px", hasBanner);

  const renderButton = (
    tab: DiscoverTabView,
    tooltip: string,
    icon: string,
  ) => {
    const handleClick = () => {
      trackEvent("Discover Sidebar Clicked", { tab });
      if (tab === DiscoverTabView.VA_SETTINGS) {
        setDiscoverTab(null);
        setOpenVaSettings(true);
        trackEvent("VA Settings Page Opened Settings");
      } else if (tab === discoverTab) {
        setDiscoverTab(null);
      } else {
        setDiscoverTab(tab);
        if (tab === DiscoverTabView.SAVED_BRANDS) {
          setTrackedCreatorSideBar(null);
        }
      }
    };

    const active = discoverTab === tab;
    return (
      <Tooltip title={tooltip} placement="left">
        <Button onClick={handleClick} sx={[active ? styles.active : {}]}>
          <Typography sx={styles.icon}>
            <Box component="i" className={icon} />
          </Typography>
        </Button>
      </Tooltip>
    );
  };

  return (
    <Box sx={styles.root}>
      <Grid container justifyContent="center" flexDirection="column">
        {renderButton(
          DiscoverTabView.SAVED_BRANDS,
          "View Saved Brands",
          "fa-thin fa-bookmark",
        )}

        {renderButton(
          DiscoverTabView.TEMPLATES,
          "View Your Templates",
          "fa-thin fa-pen-to-square",
        )}

        {renderButton(
          DiscoverTabView.METRICS,
          "View Your Metrics",
          "fa-thin fa-chart-line",
        )}
        {!currentOrg?.isBrand && (
          <>
            {renderButton(
              DiscoverTabView.CHAT,
              "Open AI Chat Helper",
              "fa-thin fa-sparkle",
            )}
          </>
        )}
      </Grid>
    </Box>
  );
}

export default HomeSideBar;
